module.exports = __webpack_public_path__ + "img/img135.aa027432.svg";